module.exports = __webpack_public_path__ + "static/img/img6.ef80814.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activity202309/img6.jpg
// module id = Ic/G
// module chunks = 0